import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICalendarState } from "@/app_redux/reducers/slices/auth/staff_calendar_slice";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { Dispatch, SetStateAction } from "react";

const StaffCalendarSlideButtons: React.FC<{
  maxLength: number;
  slideIndex: number;
  setSlideIndex: Dispatch<SetStateAction<number>>;
}> = ({ maxLength, slideIndex, setSlideIndex }) => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("STAFF_CALENDAR", "id"));
  const { calendarData } = routeState.state as ICalendarState;

  const isPrevValid = () => slideIndex > 0;

  const isNextValid = () => slideIndex < maxLength - 1;

  return (
    <div className="shrink-0">
      <div className="py-1 w-full flex justify-end items-center sm:p-2">
        <div>
          <div className="flex justify-center items-center gap-x-2 ">
            <button
              onClick={() => {
                if (isPrevValid()) {
                  setSlideIndex(slideIndex - 1);
                }
              }}
              className={clsx(
                "relative flex justify-center items-center flex-col w-9 h-9 sm:w-8 sm:h-8 rounded-md",
                isPrevValid()
                  ? "hover:bg-blue-200 bg-blue-300 text-blue-600 cursor-pointer"
                  : "bg-gray-50 text-gray-600 cursor-not-allowed",
              )}
            >
              {isPrevValid() && (
                <span className="absolute -top-1.5 -left-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] leading-none text-white">
                  {6}
                </span>
              )}
              <ChevronLeftIcon className="w-5 h-5 sm:w-6 sm:h-6" />
            </button>

            <button
              onClick={() => {
                if (isNextValid()) {
                  setSlideIndex(slideIndex + 1);
                }
              }}
              className={clsx(
                "relative flex justify-center items-center flex-col w-9 h-9 sm:w-8 sm:h-8 rounded-md",
                isNextValid()
                  ? "hover:bg-blue-200 bg-blue-300 text-blue-600 cursor-pointer"
                  : "bg-gray-50 text-gray-600 cursor-not-allowed",
              )}
            >
              {isNextValid() && (
                <span className="absolute -top-1.5 -right-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] leading-none text-white">
                  {calendarData?.length - 6}
                </span>
              )}
              <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffCalendarSlideButtons;
